// Formatage des quantités en français : séparateur de milliers en espace insécable (U+00A0), virgule
// décimale, unité séparée par une espace insécable. Une valeur absente n'est jamais 0.
//
// L'espace fine insécable (U+202F) n'existe dans aucune des polices servies par l'application (Unbounded,
// Red Hat Text) : le navigateur la prenait dans une police de secours, si étroite dans les grands chiffres en
// Unbounded que « 6 650 m³ » se lisait « 6650m³ ». L'espace insécable normale, présente dans ces polices, reste
// lisible à toutes les tailles.

import { DEFINITIONS_UNITES, type Unite } from '../constantes';
import { arrondir, estDecimal, lireDecimal, versChaine } from './decimal';

export const ESPACE_INSECABLE = ' ';
export const INDISPONIBLE = 'indisponible';

export interface OptionsFormatage {
  /** Nombre maximal de décimales affichées (par défaut 0 pour L, kg, bouteille ; 1 pour m3 et t). */
  decimales?: number;
  /** Afficher l'unité (par défaut vrai). */
  avecUnite?: boolean;
}

const DECIMALES_DEFAUT: Record<Unite, number> = { L: 0, m3: 1, kg: 0, t: 1, bouteille: 0 };

function grouperMilliers(entier: string): string {
  return entier.replace(/\B(?=(\d{3})+(?!\d))/g, ESPACE_INSECABLE);
}

export function formaterNombre(valeur: string | number, decimales = 0): string {
  const texte = typeof valeur === 'number' ? String(valeur) : valeur;
  if (!estDecimal(texte)) return INDISPONIBLE;
  const d = arrondir(lireDecimal(texte), decimales);
  const chaine = versChaine(d);
  const negatif = chaine.startsWith('-');
  const [entier = '0', fraction] = (negatif ? chaine.slice(1) : chaine).split('.');
  return (negatif ? '-' : '') + grouperMilliers(entier) + (fraction ? ',' + fraction : '');
}

export function symboleUnite(unite: Unite, quantite?: string): string {
  if (unite === 'bouteille') {
    const pluriel = quantite !== undefined && estDecimal(quantite) && Math.abs(Number(quantite)) >= 2;
    return pluriel ? 'bouteilles' : 'bouteille';
  }
  return DEFINITIONS_UNITES[unite].symbole;
}

export function formaterQuantite(
  valeur: string | null | undefined,
  unite: Unite,
  options: OptionsFormatage = {},
): string {
  if (valeur === null || valeur === undefined || !estDecimal(String(valeur))) return INDISPONIBLE;
  const nombre = formaterNombre(String(valeur), options.decimales ?? DECIMALES_DEFAUT[unite]);
  if (options.avecUnite === false) return nombre;
  return nombre + ESPACE_INSECABLE + symboleUnite(unite, String(valeur));
}
